import { ServiceBase } from '../../../../../../core/services/ServiceBase'
import BusinessSizeProxy from './proxy'

class BusinessSizeService extends ServiceBase {
  getBusinessSizeTable(params) {
    return this.getData(() => BusinessSizeProxy.getBusinessSizeTable(params))
  }
  exportBusinessSize(params) {
    return this.getFileDownload(() =>
      BusinessSizeProxy.exportBusinessSize(params),
    )
  }
}

export default new BusinessSizeService()
